import * as api from '../api'

export const getIncidents = () => async (dispatch) => {
  try {
    const { data } = await api.fetchIncidents()
    dispatch({ type: 'FETCH_INCIDENTS', payload: data })
  } catch (error) {
    dispatch({
      type: 'API_ERROR',
      payload: error,
    })
  }
}
